import { inject, Injectable, Injector } from '@angular/core';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import { MatDialog } from '@angular/material/dialog';
import { IrisModalAboutComponent } from '../../modules/about/iris-modal-about.component';
import { IrisGlobalSandbox } from '@iris/common/redux/global.sandbox';

@Injectable({ providedIn: 'root' })
export class IrisHotkeysService {
  private readonly hotkeysService = inject(HotkeysService);
  private readonly dialog = inject(MatDialog);

  private readonly injector = inject(Injector);

  constructor() {
    this.hotkeysService.add([
      new Hotkey('ctrl+,', (_event: KeyboardEvent): boolean => this.open('configuration')),
      new Hotkey('ctrl+.', (_event: KeyboardEvent): boolean => this.open('administration')),
      new Hotkey('ctrl+i', (_event: KeyboardEvent): boolean => {
        this.dialog.open(IrisModalAboutComponent, { });
        return false;
      }),
    ]);
  }

  private open(path: string): boolean {
    const sandbox = this.injector.get(IrisGlobalSandbox, null);
    const alias = sandbox?.appAlias();
    if (!alias) return false;
    window.open(`/${alias}/${path}`, '_blank');
    return false;
  }
}
